export default {
  min400: "min-width: 400px",
  min800: "min-width: 800px",
  minH480: "min-height: 480px",
  minH800: "min-height: 800px",
};
